module.exports = __webpack_public_path__ + "img/men.03cde6cd.jpg";